import axios from 'axios';

class RatingAPI {
    removeRating = async (id) => {
        return axios.delete(`api/ratings/${id}`);
    };
}

export const rating = new RatingAPI();
